import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Paper, Alert, CircularProgress } from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { verifyEmail } from '../services/api';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setError('Link inválido — falta el token de verificación.'); return; }
    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch((err) => {
        setStatus('error');
        setError(err.userMessage || 'El link es inválido o ya expiró.');
      });
  }, [token]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 2 }}>
      <Paper sx={{ maxWidth: 400, width: '100%', p: 4, borderRadius: 2, textAlign: 'center' }}>
        {status === 'loading' && (
          <>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography variant="body2" color="text.secondary">Confirmando tu email…</Typography>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircleIcon color="success" sx={{ fontSize: 48, mb: 1 }} />
            <Typography variant="h6" fontWeight={700} mb={1}>¡Email confirmado!</Typography>
            <Typography variant="body2" color="text.secondary" mb={3}>
              Tu cuenta ya está activa. Ya podés iniciar sesión.
            </Typography>
            <Button component={Link} to="/login" variant="contained" fullWidth>
              Iniciar sesión
            </Button>
          </>
        )}

        {status === 'error' && (
          <>
            <Alert severity="error" sx={{ mb: 2, textAlign: 'left' }}>{error}</Alert>
            <Typography variant="body2" color="text.secondary" mb={2}>
              Si el link expiró, podés pedir uno nuevo desde la pantalla de inicio de sesión.
            </Typography>
            <Button component={Link} to="/login" variant="outlined" fullWidth>
              Volver al login
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default VerifyEmail;
